module.exports = __webpack_public_path__ + "img/Sleeves-Front-B9-Da-Eb-Gd.1d394cab.png";